import React from 'react';

// TODO: Заменить на реальную ссылку на телеграм поддержки
const TELEGRAM_SUPPORT_LINK = 'https://t.me/your_support_bot';

const SIZE_CLASSES = {
  large: {
    wrap: 'w-full flex flex-1 mt-10 p-1',
    container: 'container relative flex flex-1 flex-col mx-auto max-w-[1163px]',
    card: 'flex flex-col items-center justify-center min-h-[400px] bg-white border border-gray-200 rounded-lg p-8',
    icon: 'h-20 w-20 mx-auto text-red-500 mb-4',
    title: 'text-2xl font-bold text-gray-800 mb-2',
    text: 'text-gray-600 mb-6',
    button: 'inline-flex items-center gap-2 text-center border rounded py-3 px-6 bg-button text-white hover:bg-button-hov transition ease-in-out duration-300',
    buttonIcon: 'h-5 w-5',
  },
  medium: {
    wrap: 'w-full flex justify-center mt-4 p-1',
    container: 'w-full max-w-[520px]',
    card: 'w-full flex flex-col items-center justify-center bg-white border border-gray-200 rounded-lg p-5',
    icon: 'h-12 w-12 mx-auto text-red-500 mb-3',
    title: 'text-xl font-bold text-gray-800 mb-2',
    text: 'text-sm text-gray-600 mb-4',
    button: 'inline-flex items-center gap-2 text-center border rounded py-2 px-4 bg-button text-white hover:bg-button-hov transition ease-in-out duration-300',
    buttonIcon: 'h-4 w-4',
  },
  small: {
    wrap: 'w-full flex justify-center h-full',
    container: 'w-full max-w-[360px] flex',
    card: 'w-full flex flex-col items-center justify-center bg-white border border-gray-200 rounded-md p-3',
    icon: 'h-8 w-8 mx-auto text-red-500 mb-2',
    title: 'text-base font-bold text-gray-800 mb-1',
    text: 'text-xs text-gray-600 mb-0',
    button: 'inline-flex items-center gap-2 text-center border rounded py-1 px-3 bg-button text-white hover:bg-button-hov transition ease-in-out duration-300 mt-3 text-xs',
    buttonIcon: 'h-3 w-3',
  },
};

export default function AccessDenied({ compact = false, size = 'large', title = 'Доступ запрещен', description = 'У вас нет полномочий для просмотра данной страницы.', supportText = 'Для изменения доступа напишите сюда:', buttonText = 'Написать в поддержку', showSupportButton = true }) {
  const resolvedSize = compact && size === 'large' ? 'medium' : size;
  const ui = SIZE_CLASSES[resolvedSize] || SIZE_CLASSES.large;

  return (
    <div className={ui.wrap}>
      <div className={ui.container}>
        <div className={ui.card}>
          <div className="text-center">
            <svg xmlns="http://www.w3.org/2000/svg" className={ui.icon} fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
            <h2 className={ui.title}>{title}</h2>
            <p className={ui.text}>
              {description}
              {supportText ? (
                <>
                  <br />
                  {supportText}
                </>
              ) : null}
            </p>
            {showSupportButton && (
              <a href={TELEGRAM_SUPPORT_LINK} target="_blank" rel="noopener noreferrer" className={ui.button}>
                <svg xmlns="http://www.w3.org/2000/svg" className={ui.buttonIcon} viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm5.562 8.161c-.18 1.897-.962 6.502-1.359 8.627-.168.9-.5 1.201-.82 1.23-.697.064-1.226-.461-1.901-.903-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.139-5.062 3.345-.479.329-.913.489-1.302.481-.428-.009-1.252-.242-1.865-.442-.751-.244-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.831-2.529 6.998-3.015 3.333-1.386 4.025-1.627 4.477-1.635.099-.002.321.023.465.141.121.1.154.234.169.327.015.093.034.306.019.472z" />
                </svg>
                {buttonText}
              </a>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
